<div *ngIf="isAuthenticating">
  Authenticating...Please Wait
</div>

<!--<button (click)="onLoginClick()"
        *ngIf="!isAuthenticating">Login</button>-->
